import { render } from "./ProdutoCarregamento.vue?vue&type=template&id=86e3645a&scoped=true"
import script from "./ProdutoCarregamento.vue?vue&type=script&lang=js"
export * from "./ProdutoCarregamento.vue?vue&type=script&lang=js"

import "./ProdutoCarregamento.vue?vue&type=style&index=0&id=86e3645a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86e3645a"]])

export default __exports__